import { logger } from '@/helpers/logger';

const TASKS_MATCHER = new RegExp(
  '<[hp]\\d?><b>Aufgaben<\\/b><\\/[hp]\\d?>(.*?)(?=<[hp]\\d?><b>Anforderungen)',
  's'
);
const REPLACEMENT_TASKS = '<h2>Aufgaben</h2>';

export const transformWorkdayHtmlTasks = (workdayHtml: string) => {
  const [, matchedHtml = ''] = workdayHtml.match(TASKS_MATCHER) || [];

  if (!matchedHtml) {
    logger.error('[invalid workday html (tasks) ]', { workdayHtml });
    return 'Leider gab es einen Fehler';
  }

  return REPLACEMENT_TASKS + matchedHtml;
};
